import { Injectable } from '@angular/core';
import { FatalErrorCategoryEnum, SceneJSFatalErrorModel } from './error/error.model';
import { WidgetFatalErrorCategoryEnum } from '../widget/models/widget-error-type.enum';
import { LocationStrategy } from '@angular/common';
import { Router } from '@angular/router';
import { ErrorMessage, ErrorLoggingService } from './error-logging.service';
import { environment } from 'src/environments/environment';
import { EnvironmentApplication } from 'src/environments/models/environment-application';

declare const Human: any;

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  constructor(
    private locationStrategy: LocationStrategy,
    private router: Router,
    private errorLoggingService: ErrorLoggingService
  ) {
    
    // init handling of fatal SceneJS errors
    // pass SceneJS a callback to invoke when it detects a fatal error.
    (window as any).SceneJS_error.setFatalErrorHandler(
      this.handleSceneJSFatalErrors.bind(this)
    );
  }

  handleSceneJSFatalErrors(errorDescriptor: SceneJSFatalErrorModel) {
    // extract engine errors
    const engineErrorLog = {
      log: Human.log.messages.join('\n'),
      stack: errorDescriptor.stackTrace,
      webglInfo: (window as any).SceneJS.WEBGL_INFO
    };

    // prep error message
    const errorMessage: ErrorMessage = {
      category: errorDescriptor.errorName,
      log: JSON.stringify(engineErrorLog),
      message: errorDescriptor.messageFromCaller
    };

    // log error
    this.errorLoggingService
      .logError(errorMessage, true)
      .subscribe();

    const errorBlob = btoa(JSON.stringify(errorDescriptor));
    this.redirectToErrorPage(FatalErrorCategoryEnum.SceneJS, undefined, errorBlob);
  }

  redirectToErrorPage(
    errorType: FatalErrorCategoryEnum | WidgetFatalErrorCategoryEnum,
    errorCode?: string,
    errorBlob?: string
  ) {
    // don't redirect to /error page if current route is /error
    const url = this.router.url || '';
    if (url.match('/error')) {
      return;
    }

    const basePath = this.locationStrategy.getBaseHref();

    const errorURL =
      environment.application === EnvironmentApplication.Viewer
        ? `${basePath}/error`
        : `${basePath}/view/error`;

    const urlTree = this.router.createUrlTree([errorURL], {
      queryParams: {
        errorType,
        errorCode,
        errorBlob,
        errorUrl: this.router.url
      }
    });

    const redirectPath = this.router.serializeUrl(urlTree);
    window.location.href = redirectPath;
  }

}
